var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import Loader from '@components/v2/Loader';
import ComponentQuestionsTable from './ComponentQuestionsTable';
import AddComponentQuestionModal from './components/AddComponentQuestionModal';
import QuestionSetDetailModal from './components/QuestionSetDetailModal';
import { useComponentQuestionSets, useUpdateComponentQuestionSetMutation, useToggleComponentQuestionSetStatusMutation } from './hooks/useComponentQuestionSetsMutations';
import './ComponentQuestionsSettingsStyles.scss';
const namespace = 'features.settings.component_questions';
export default function ComponentQuestionsSettings() {
    const [selectedQuestionSet, setSelectedQuestionSet] = useState(null);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const { data: questionSets = [], isLoading, isError, error } = useComponentQuestionSets();
    const updateMutation = useUpdateComponentQuestionSetMutation();
    const toggleActiveMutation = useToggleComponentQuestionSetStatusMutation();
    const handleNewQuestionSetClick = () => {
        setIsAddModalOpen(true);
    };
    const handleEditClick = (questionSet) => {
        setSelectedQuestionSet(questionSet);
        setIsDetailModalOpen(true);
    };
    const handleUpdate = (setId, field, value) => __awaiter(this, void 0, void 0, function* () {
        yield updateMutation.mutateAsync({
            id: setId,
            data: { [field]: value }
        });
    });
    const handleToggleActive = (setId) => __awaiter(this, void 0, void 0, function* () {
        yield toggleActiveMutation.mutateAsync(setId);
        setSelectedQuestionSet(null);
        setIsDetailModalOpen(false);
    });
    const handleCloseDetailModal = () => {
        setIsDetailModalOpen(false);
        setSelectedQuestionSet(null);
    };
    if (isLoading) {
        return (React.createElement("div", { className: "component-questions-settings" },
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "loading-state" },
                    React.createElement(Loader, { label: translate('loading', { namespace: 'features.commons' }) })))));
    }
    if (isError) {
        return (React.createElement("div", { className: "component-questions-settings" },
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "error-state" },
                    React.createElement("i", { className: "fa-light fa-exclamation-triangle", "aria-hidden": "true" }),
                    React.createElement("p", null, translate('error_loading', { namespace })),
                    React.createElement("p", null, error === null || error === void 0 ? void 0 : error.message)))));
    }
    return (React.createElement("div", { className: "component-questions-settings" },
        React.createElement("div", { className: "content" },
            React.createElement("header", { className: "content-header" },
                React.createElement("div", { className: "content-header__left" },
                    React.createElement("h1", { className: "content-header__title" }, translate('title', { namespace }))),
                React.createElement("div", { className: "content-header__right" },
                    React.createElement(Button, { variant: "primary", onClick: handleNewQuestionSetClick },
                        React.createElement("i", { className: "fa-light fa-plus", "aria-hidden": "true" }),
                        translate('new_question_set', { namespace })))),
            React.createElement("hr", { className: "content-separator" }),
            React.createElement("div", { className: "content-table" },
                React.createElement("p", { className: "content-description" }, translate('description', { namespace })),
                React.createElement(ComponentQuestionsTable, { questionSets: questionSets, onEditClick: handleEditClick }))),
        React.createElement(AddComponentQuestionModal, { isOpen: isAddModalOpen, onClose: () => setIsAddModalOpen(false) }),
        React.createElement(QuestionSetDetailModal, { isOpen: isDetailModalOpen, onClose: handleCloseDetailModal, questionSet: questionSets.find((qs) => qs.id === (selectedQuestionSet === null || selectedQuestionSet === void 0 ? void 0 : selectedQuestionSet.id)) || null, onToggleActive: handleToggleActive, onUpdate: handleUpdate, isTogglingActive: toggleActiveMutation.isLoading })));
}
